import { SyntheticEvent, useEffect, useState } from 'react';
import { statusList, statusToBE } from '.';

type UseViewModelProps = {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
};

type UseViewModelReturn = {
  status: string;
  anchorEl: HTMLButtonElement;
  handleClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
  handleClose: () => void;
  handleChange: (item: string) => void;
};

const useViewModel = ({
  value,
  onChange,
  disabled,
}: UseViewModelProps): UseViewModelReturn => {
  const handleChange = (item: string): void => {
    const newValue =
      item === statusList[0] ? '' : statusToBE?.[item.toLowerCase()] ?? item;

    setStatus(item);
    onChange(newValue);
    setAnchorEl(null);
  };

  useEffect(() => {
    if (disabled) {
      setStatus(statusList[0]);
    }
  }, [disabled]);

  const [status, setStatus] = useState(value === '' ? statusList[0] : value);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>(null);

  const handleClick = (event: SyntheticEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return {
    status,
    anchorEl,
    handleClick,
    handleClose,
    handleChange,
  };
};

export default useViewModel;
